import React, { Component } from 'react';
import AssignedUserCard from './Assigned/AssignedUserCard';
import { Button } from '@blueprintjs/core';
import ReactSelectAsyncContainer from '../../reactSelectWrappers/ReactSelectAsyncContainer';

class PMContactSection extends Component {
	render() {
		const p = this.props;
		return (
			<div className={"PMContactSection"}>
				{this.header()}
				<div className={"PMAssignmentList"}>
					{p.users !== undefined ? this.list() : null}
				</div>
				<span>Add</span>
				<ReactSelectAsyncContainer
					queryName={'PM.SearchContacts'}
					attr={'Phrase'}
					defaultParams={{CardCode: p.BPuniqueID}}
					typeName={'Phrase'}
					focus={true}
					querySearch={false}
					minimumAttributeLength={2}
					onChange={p.addAssignedContact}
					returnObj={{ attr: 'display' }}
				/>
			</div>
		);
	}

	header = () => {
		const p = this.props;
		return (
			<div> <h3>{p.header}</h3></div>
		)
	}

	list = () => {
		const p = this.props;

		return p.users.map((user, index) => {
			return <AssignedUserCard
				key={user + "_" + index}
				user={user}
				removeAssigned={p.removeAssigned}
			/>
		})
	}
}

export default PMContactSection;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMContactSection.js